import { onBecomeObserved, onBecomeUnobserved, runInAction } from "mobx";
import { atom, MobxAtom } from "../atom";
import { EnvironmentVariableValue } from "../Types";
import { ParentComlinkAPI, ParentIframeEventEmitter } from "./FrameSandboxAPI";

const environmentVariableAtomMap: {
  [key: string]: MobxAtom<EnvironmentVariableValue>;
} = {};

export function getEnvironmentVariableAtom(key: string) {
  if (environmentVariableAtomMap[key] === undefined) {
    const variableAtom = atom<EnvironmentVariableValue>(["loading"]);
    async function go() {
      if (variableAtom.value[0] !== "loading") {
        runInAction(() => {
          variableAtom.value = ["loading"];
        });
      }
      const value = await ParentComlinkAPI.getEnvironmentVariable(key);
      runInAction(() => {
        if (value[0] === "unauthorized") {
          variableAtom.value = ["unauthorized"];
        } else if (value[1] === undefined) {
          variableAtom.value = ["missing"];
        } else {
          variableAtom.value = ["value", value[1]];
        }
      });
    }
    function onVariableChange({ variableKey }: { variableKey: string }) {
      if (variableKey === key || variableKey === "*") {
        go();
      }
    }
    onBecomeObserved(variableAtom, "value", () => {
      go();
      ParentIframeEventEmitter.addListener(
        "ENVIRONMENT_VARIABLE_CHANGE",
        onVariableChange
      );
    });
    onBecomeUnobserved(variableAtom, "value", () => {
      ParentIframeEventEmitter.removeListener(
        "ENVIRONMENT_VARIABLE_CHANGE",
        onVariableChange
      );
    });
    environmentVariableAtomMap[key] = variableAtom;
  }
  return environmentVariableAtomMap[key];
}
